import React, { useRef } from 'react';
import PropTypes from 'prop-types';
// Context
// import { FormDataContext } from 'globalState/FormDataContext';
// Import components
import Input from 'components/shared/FormElements/Input/Input';
// import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';

const Contact = (props) => {
  // const [, formDispatch] = useContext(FormDataContext); // Get the state of form data from FormDataContext
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register, handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)
  const { section, header, summary } = props;

  // const [formDataState] = useContext(FormDataContext);

  // Labels used on inputs and for validation
  const emailLabel = 'Email address';
  // Logic used to validate the email field
  const emailRegex =
    /^[\w!#$%&amp;'*+\-/=?^_`{|}~]+(\.[\w!#$%&amp;'*+\-/=?^_`{|}~]+)*@((([-\w]+\.)+[a-zA-Z]{2,4})|(([0-9]{1,3}\.){3}[0-9]{1,3}))$/; // Matches email regex on server

  // Logic used to validate fields - optional fields
  const fieldValidation = () => {
    return register({ required: false });
  };

  // email validation - required and must be valid format
  const emailValidation = register({
    required: `${emailLabel} is required`,
    pattern: {
      value: emailRegex,
      message: `Enter an ${emailLabel.toLowerCase()} in the correct format`,
    },
  });

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      <div className="wmcads-progress-indicator">
        {section}
        <h4>{header}</h4>
      </div>

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <div className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">How would you like to be contacted?</h2>
          <p>{summary}</p>
        </div>
        <div className="">
          <Input
            className="wmcads-col-1 wmcads-col-lg-3-4"
            name="emailAddress"
            label="Email address *<br> For example, name@example.com"
            autocomplete="given-name"
            fieldValidation={emailValidation}
          />
        </div>
        <div className="">
          <Input
            className="wmcads-col-1 wmcads-col-lg-3-4"
            name="ContactPhone"
            label="Phone number<br> For example, 07700900457"
            autocomplete="given-name"
            fieldValidation={fieldValidation('Phone number')}
          />
        </div>
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

Contact.propTypes = {
  summary: PropTypes.string,
  section: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};

Contact.defaultProps = {
  summary: '',
};

export default Contact;
